module.exports = __webpack_public_path__ + "img/main7.4f33b7de.png";